// @ts-nocheck
import { name2num, num2name, } from "./(EstimatedInfo)/UserSeg";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../runtime/json/scalar";
import { WireType, } from "../../../runtime/wire/index";
import { default as serialize, } from "../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../runtime/wire/scalar";
import { default as Long, } from "../../../runtime/Long";
import { default as deserialize, } from "../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        score: "",
        userSeg: "USER_SAG_UNSPECIFIED",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.score !== undefined)
        result.score = tsValueToJsonValueFns.string(value.score);
    if (value.userSeg !== undefined)
        result.userSeg = tsValueToJsonValueFns.enum(value.userSeg);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.score !== undefined)
        result.score = jsonValueToTsValueFns.string(value.score);
    if (value.userSeg !== undefined)
        result.userSeg = jsonValueToTsValueFns.enum(value.userSeg);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.score !== undefined) {
        const tsValue = value.score;
        result.push([1, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.userSeg !== undefined) {
        const tsValue = value.userSeg;
        result.push([2, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.score = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.userSeg = value;
    }
    return result;
}
